import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Apiconnect from "../services/Apiconnect.js";
import { AuthContext } from '../AuthProvider.js';

const Script_Generation = () => {
  const [formData, setFormData] = useState({
    botName: 'AI Assistant',
    welcomeMessage: 'Hello! How can I help you today?',
    inputPlaceholder: 'Type message...',
    primaryColor: '#0d6efd',
    widgetPosition: 'Bottom Right',
  });

  const [myscript, setMyscript] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const { userInfo, isLoading } = useContext(AuthContext);
  console.log(userInfo);

  // Fetch existing data when component mounts
  useEffect(() => {
    fetchExistingData();
  }, []);

  // Update script whenever form data changes
  useEffect(() => {
    updateScript();
  }, [formData]);

  const fetchExistingData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await Apiconnect.getData("chatbot_script", token);
      console.log("response,", response);

      if (response.data && response.data.status === 1 && response.data.data) {
        const chatbotData = response.data.data;
        console.log(chatbotData);
        console.log(token);

        // Format the position string from "bottom-right" to "Bottom Right" format
        const formattedPosition = chatbotData.chat_position
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        // Update form data with existing values
        setFormData({
          botName: chatbotData.name || 'AI Assistant',
          welcomeMessage: chatbotData.welcome_msg || 'Hello! How can I help you today?',
          inputPlaceholder: chatbotData.input_placeholder || 'Type message...',
          primaryColor: chatbotData.chat_color || '#0d6efd',
          widgetPosition: formattedPosition || 'Bottom Right',
        });

        // Set the script if available
        if (chatbotData.chat_script) {
          setMyscript(chatbotData.chat_script);
        } else {
          // If no script is available, generate one
          updateScript();
        }
      } else {
        // If no data available, generate script with default values
        updateScript();
      }
    } catch (error) {
      console.error("Error fetching existing data:", error);
      // On error, generate script with default values
      updateScript();
    } finally {
      setLoading(false);
    }
  };

  const updateScript = () => {
    // Get customer ID from localStorage
    const custId = localStorage.getItem('custId') || "test_customer";

    const scriptTemplate = `
<script>
  (function() {
      // Configuration
      const chatbotConfig = {
          "custId": "${custId}", 
          "name": "${formData.botName}", 
          "welcomeMessage": "${formData.welcomeMessage}", 
          "inputPlaceholder": "${formData.inputPlaceholder}", 
          "primaryColor": "${formData.primaryColor}", 
          "position": "${formData.widgetPosition.toLowerCase().replace(' ', '-')}", 
          "autoOpen": true, 
          "apiEndpoint": "https://api.aignt.in/", 
          "apiKey": ""
      };
      
      // Create chatbot container
      const container = document.createElement('div');
      container.id = 'saicb-chatbot-container';
      document.body.appendChild(container);
      
      // Load styles
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = 'https://api.aignt.in/static/chatbot.css';
      document.head.appendChild(style);
      
      // Load chatbot script
      const script = document.createElement('script');
      script.src = 'https://api.aignt.in/static/chatbot.js';
      script.async = true;
      
      // Initialize chatbot when script loads
      script.onload = function() {
          if (typeof window.initializeChatbot === 'function') {
              window.initializeChatbot(chatbotConfig);
          } else {
              console.error('SAICB Chatbot initialization failed: initializeChatbot not found');
          }
      };
      
      // Handle script load errors
      script.onerror = function() {
          console.error('SAICB Chatbot failed to load required resources');
      };
      
      // Add script to page
      document.head.appendChild(script);
  })();
</script>`;

    setMyscript(scriptTemplate);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleGenerateScript = async () => {
    try {
      setError(false);
      const formdata = new FormData();
      formdata.append('name', formData.botName);
      formdata.append('welcome_msg', formData.welcomeMessage);
      formdata.append('input_placeholder', formData.inputPlaceholder);
      formdata.append('chat_color', formData.primaryColor);
      formdata.append('chat_position', formData.widgetPosition.toLowerCase().replace(' ', '-'));
      formdata.append('chat_script', myscript);

      const token = localStorage.getItem('token');
      const response = await Apiconnect.postData("chatbot_script", formdata, token);

      if (response.data && response.data.status === 1) {
        toast.success(response.data.message || "Chat Script Generated/Updated Successfully");
        // Refresh data after successful update
        fetchExistingData();
      } else {
        toast.error(response.data.message || "Error Occurred");
        setError(true);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error connecting to the server");
      setError(true);
    }
  };

  return (
    <div className="container-fluid">
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <h2 className="mb-4 fw-bold">Generate Chatbot Script</h2>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading your chatbot configuration...</p>
            </div>
          ) : (
            <>
              <div className="row mb-4 gx-4">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label text-muted small">Bot Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="botName"
                      value={formData.botName}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label text-muted small">Welcome Message</label>
                    <input
                      type="text"
                      className="form-control"
                      name="welcomeMessage"
                      value={formData.welcomeMessage}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-4 gx-4">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label text-muted small">Input Placeholder</label>
                    <input
                      type="text"
                      className="form-control"
                      name="inputPlaceholder"
                      value={formData.inputPlaceholder}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label text-muted small">Primary Color</label>
                    <input
                      type="color"
                      className="form-control form-control-color w-100"
                      name="primaryColor"
                      value={formData.primaryColor}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label text-muted small">Widget Position</label>
                    <select
                      className="form-select"
                      name="widgetPosition"
                      value={formData.widgetPosition}
                      onChange={handleInputChange}
                    >
                      <option>Bottom Right</option>
                      <option>Bottom Left</option>
                      <option>Top Right</option>
                      <option>Top Left</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row mb-4 gx-4">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label text-muted small">User Info Script</label>
                    <textarea
                      className="form-control font-monospace"
                      rows={10}
                      readOnly
                      value={`<!-- AiGNT CHAT SCRIPT | Put it before any other external chat -->
<script src="https://api.aignt.in/aichat/${userInfo?.user_id || "userinfo.user_id"}"></script>
<!-- END of AiGNT CHAT SCRIPT -->`}
                    />
                  </div>
                </div>
              </div>

              <textarea
                style={{ display: "none" }}
                name="chat_script"
                value={myscript}
                readOnly
              />


              <div className="mt-2">
                <button
                  className="btn btn-primary d-flex align-items-center px-4"
                  onClick={handleGenerateScript}
                >
                  <i className="bi bi-play-fill me-2"></i> GENERATE SCRIPT
                </button>
              </div>

              {error && (
                <div className="alert alert-danger mt-4 d-flex align-items-center">
                  <i className="bi bi-exclamation-circle-fill me-2"></i>
                  An unexpected error occurred
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Script_Generation;